import TaskType from '../Models/TaskType';
import DataGridRequest from './DataGridRequest';
export class DealTypeRequest extends DataGridRequest<TaskType> {
    Url = '/api/v1/settings/deal_types';
}
